<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'main-menu',
  computed: {
    ...mapGetters([ 'isAuthenticated', 'getCartId' ]),
    ...mapState([ 'cart', 'activeMenuIndex' ]),
    ...mapActions([ 'aLogout', 'aFetchCartTotal' ]),
    routes () {
      let routes = this.$router.options.routes
      let toFilter = [ 'cart-items', 'user-account', 'login', 'logout' ]
      let seletedRoutes = {}
      toFilter.forEach((key, index) => {
        seletedRoutes[ key ] = routes.find(route => route.name === key)
      })
      return seletedRoutes
    }
  },
  methods: {
    handleMethod: function (methodName) {
      if (methodName) {
        this[ methodName ]()
      }
    }
  }
}
</script>

<template>
  <el-menu
    class="user-menu"
    mode="horizontal"
    router
  >
    <el-submenu
      index="2"
      v-if="isAuthenticated"
    >
      <template slot="title"><i class="el-icon-user-solid"></i></template>
      <el-menu-item :index="routes['user-account'].path">
        <i :class="routes['user-account'].meta.icon"></i>
        {{ routes['user-account'].meta.label }}
      </el-menu-item>
      <el-menu-item
        :index="routes['logout'].path"
        @click="handleMethod(routes['logout'].meta.click)"
      >
        <i :class="routes['logout'].meta.icon"></i>
        {{ routes['logout'].meta.label }}
      </el-menu-item>
    </el-submenu>
    <el-menu-item
      :index="routes['login'].path"
      v-if="!isAuthenticated"
    >
      <i :class="routes['login'].meta.icon"></i>
      {{ routes['login'].meta.label }}
    </el-menu-item>
    <el-menu-item
      :index="routes['cart-items'].path"
      :disabled="getCartId ? false : true"
    >
      <i :class="routes['cart-items'].meta.icon"></i>
      <el-badge
        :value="cart.itemCount"
        type="primary"
        v-if="getCartId"
      >
      </el-badge>
    </el-menu-item>
  </el-menu>
</template>


// WEBPACK FOOTER //
// src/components/user-menu.vue